import { CalendarIcon } from '@chakra-ui/icons';
import { Button, ButtonGroup } from '@chakra-ui/react';
import moment from 'moment';
import { BooleanSupportOption } from 'prettier';

type ButtonDateRangerProps = {
  isChosenDate: boolean;
  setIsChosenDate: any;
  setIsOpenDatePicker: any;
  startDate: string;
  endDate: string;
};

export const ButtonDateRanger = ({
  isChosenDate,
  setIsChosenDate,
  setIsOpenDatePicker,
  startDate,
  endDate
}: ButtonDateRangerProps) => {
  return (
    <ButtonGroup
      bg={isChosenDate ? '#001E64' : '#FFFFFF'}
      isAttached
      variant="outline"
      borderRadius="24px"
      border={isChosenDate ? 'none' : '1px solid #001E64 !important'}
    >
      <Button
        h="48px"
        w="134px"
        display="flex"
        alignItems="center"
        gridGap="10px"
        color={isChosenDate ? '#FFFFFF' : '#828282'}
        fontSize="1rem"
        fontWeight="400"
        lineHeight="1.5rem"
        borderRadius="24px"
        onClick={() => {
          setIsOpenDatePicker(true);
          setIsChosenDate(false);
        }}
        _hover={{}}
        _active={{}}
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
      >
        <CalendarIcon />
        {moment(startDate).format('DD-MM-YY').replaceAll('-', '/')}
      </Button>
      <Button
        h="48px"
        w="134px"
        display="flex"
        alignItems="center"
        gridGap="10px"
        color={isChosenDate ? '#FFFFFF' : '#828282'}
        fontSize="1rem"
        fontWeight="400"
        lineHeight="1.5rem"
        borderLeft={
          isChosenDate
            ? '0.5px solid #FFFFFF !important'
            : '0.5px solid #001E64 !important'
        }
        borderRadius="24px"
        onClick={() => {
          setIsOpenDatePicker(true);
          setIsChosenDate(false);
        }}
        _hover={{}}
        _active={{}}
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
      >
        <CalendarIcon />
        {moment(endDate).format('DD-MM-YY').replaceAll('-', '/')}
      </Button>
    </ButtonGroup>
  );
};
